import { getSetting } from '@disy/workbook.lib/settings';

import type { WorksheetDto } from 'cadenza/workbook/api/worksheet-dto';
import { WorksheetSettingsKey } from 'cadenza/workbook/model/worksheet-settings-key.gen';

export interface LiveModeRefreshInterval {
  milliseconds: number;
  isDefault: boolean;
}

export function getCurrentRefreshInterval(worksheetDto: WorksheetDto, refreshIntervals: LiveModeRefreshInterval[]) {
  const milliseconds = getSetting<number>(
    worksheetDto,
    WorksheetSettingsKey.toPersistenceKey('PERIODICAL_QUERY_EXECUTION_INTERVAL'),
  );
  return milliseconds ? refreshIntervals.find((choice) => choice.milliseconds === milliseconds) : undefined;
}

export function getDefaultRefreshInterval(refreshIntervals: LiveModeRefreshInterval[]) {
  return refreshIntervals.find((choice) => choice.isDefault)!;
}
